<script>
	import request from './request.vue';
	import Category from './category.model.vue';

	import { format } from "date-fns";

	const articleSchema = [
		{
			name: "id",
			displayName: "Código",
			kind: "text",
			validation: "",
			placeholder: "Digite o código da empresa",
			defaultSort: true,
			readOnly: true,
			search: {
				show: false,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "name",
			displayName: "Nome",
			kind: "text",
			validation: "required",
			placeholder: "Digite o nome do curso",
			defaultSort: true,
			notInFilters: false,
			search: {
				show: true,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "creationDate",
			displayName: "Data do cadastro",
			kind: "text",
			validation: "",
			placeholder: "",
			readOnly: true,
			notInFilters: true,
			formatter: value => format(value, "DD/MM/YYYY HH:mm"),
			creationHidden: true,
			search: {
				show: true,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "description",
			displayName: "Descrição",
			kind: "text",
			validation: "",
			placeholder: "",
		},
		{
			name: "introduction",
			displayName: "Introdução",
			//kind: "text",
			kind: "html",
			validation: "required",
			placeholder: "",
			editorId: "txtArticleIntroduction",
			editorConfig: {
					plugins: "save emoticons image link media preview table textcolor autosave",
					toolbar: "save restoredraft | undo redo | styleselect bold italic forecolor backcolor | alignleft aligncenter alignright table | outdent indent | image link media | preview emoticons",
					statusbar: false,
			}
		},
		{
			name: "introductionTest",
			displayName: "Introdução p/testes",
			//kind: "text",
			kind: "html",
			//validation: "required",
			placeholder: "",
			editorId: "txtArticleIntroductionTest",
			editorConfig: {
					plugins: "save emoticons image link media preview table textcolor autosave",
					toolbar: "save restoredraft | undo redo | styleselect bold italic forecolor backcolor | alignleft aligncenter alignright table | outdent indent | image link media | preview emoticons",
					statusbar: false,
			}
		},
		{
			name: "categoryId",
			displayName: "Categoria",
			validation: "required",
			kind: "select",
			placeholder: "",
			options: [],
			search: {
				show: false,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "audioUrl",
			displayName: "Aúdio",
			kind: "file-url",
			validation: "",
			placeholder: "",
			search: {
				show: false,
			},
			upload: async function (id, file) {
				const formData = new FormData();
				formData.append("file", file, file.name);
				let response = await request.sendFormData("article", `addAudio/${id}`, formData);
				return response.data;
			},
		},
		{
			name: "bannerUrl",
			displayName: "Banner",
			kind: "file-url",
			validation: "",
			placeholder: "",
			search: {
				show: false,
			},
			upload: async function (id, file) {
				const formData = new FormData();
				formData.append("file", file, file.name);
				let response = await request.sendFormData("article", `addBanner/${id}`, formData);
				return response.data;
			},
		},
		{
			name: "video",
			displayName: "Vídeo",
			kind: "video-url",
			validation: "",
			placeholder: "",
			search: {
				show: false,
			},
			upload: async function (id, file) {
				const formData = new FormData();
				formData.append("file", file, file.name);
				let response = await request.sendFormData("article", `addVideo/${id}`, formData);
				return response.data;
			},
		},
		{
			name: "idSAP",
			displayName: "IDSAP",			
			kind: "text",
			placeholder: "",
		},
	];

	Category.getAll()
		.then((categories) => {
			articleSchema.find(field => field.name === "categoryId").options = categories.map(category => ({
				name: category.name,
				value: category.id,
			}));
		})
		.catch((err) => console.log(err));

	export default {
		create: async function (entity) {
			const response = await request.send("article", "create", entity, true);
			return response.data;
		},
		getInfo: async function (id) {
			const response = await request.send("article", "read", { id }, true);
			return response.data;
		},
		updateInfo: async function (article) {
			delete article.video;
			let response = await request.send("article", "update", article, true);
			return response.data;
		},
		remove: async function (id) {
			return request.send("article", "delete", { id }, true);
		},
		search: async function(parameters) {
			return request.send("article", "search", parameters, true);
		},
		getAll: async function() {
			const response = await request.send("article", "getAll", {}, true);
			return response.data;
		},
		findTestsByCategory: async function(categoryId, articleIdExclude = 0) {
			const response = await request.send("article", "findTestsByCategoryAll", { categoryId, articleIdExclude }, true);
			return response.data;
		},
		uploadVideo: async function(data, id, inDescription = false) {
			const response = await request.sendFormData("article", `addVideo/${id}/${inDescription}`, data);
			return response;
		},
		getSchema: function () {
			return articleSchema;
		},
	}
</script>
